<template>
  <div class="banner-wrapper">
    <div class="content">
      <img src="@/assets/img/banner/header_logo.png" alt="" />
      <div class="text">
        <div class="main">{{ supervisionCenterInfo.supervisionTitle || '九龙坡市场监督管理局' }}</div>
        <div class="sub">数字药监•智慧监管预警系统</div>
        <div class="icon">药店端</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('permission', ['supervisionCenterInfo'])
  }
};
</script>

<style lang="scss">
.banner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 120px;
  background-image: url('~@/assets/img/new/ydyj_bg.png');
  background-size: cover;
  background-repeat: no-repeat;

  .content {
    display: flex;

    img {
      height: 70px;
    }

    .text {
      position: relative;
      flex: 1;
      top: -6px;
      font-size: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-left: 6px;

      .icon {
        position: absolute;
        top: 12px;
        right: 0px;
        padding: 3px 6px;
        background-color: #143a73;
        color: #fff;
        font-size: 12px;

        border-radius: 4px;
        transform: translate(100%, -50%);
      }

      .main {
        margin-bottom: 5px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #143a73;
        letter-spacing: 2px;
      }

      .sub {
        width: 100%;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #143a73;
        line-height: 11px;
        text-align: justify;
        text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
        text-align-last: justify;
      }
    }
  }
}
</style>
